if (!customElements.get('maisonco-bogo-timer')) {
  customElements.define('maisonco-bogo-timer', class extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      if (!Number.isFinite(this.end)) return;
      this.update();
      this.interval = window.setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const minutes = Math.max(0, Math.floor((this.end - Date.now()) / 60000));
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      this.querySelector('[data-days]').textContent = days;
      this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(minutes % 60).padStart(2, '0');
      this.hidden = minutes === 0;
    }
  });
}
